import { Avatar, FlexBox } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';

import { Highlight } from 'components/highlight';

import '../styles/userItem.less';

type UserItemProps = {
  user: any;
  closeDropDown: () => void;
  add: (payload: { user: User }) => void;
  highlighted: boolean;
  resetValue: () => void;
};

const UserItem = ({
  user,
  closeDropDown,
  add,
  highlighted,
  resetValue,
}: UserItemProps) => {
  let email: JSX.Element | string = '';
  let name: JSX.Element | string = '';
  let avatar = <Avatar user={user} />;
  let highlightedClassName = '';

  if (user.icon !== undefined) {
    avatar = <Avatar icon={user.icon} />;
  }

  if (user._highlights?.display_name?.length) {
    name = <Highlight highlightedValue={user._highlights.display_name[0]} />;
  } else if (
    typeof user.name === 'string' ||
    typeof user.display_name === 'string'
  ) {
    name = typeof user.name === 'string' ? user.name : user.display_name;
  }

  if (!user.duplicate && user._highlights?.email?.length) {
    email = <Highlight highlightedValue={user._highlights.email[0]} />;
  } else if (typeof user.email === 'string') {
    email = user.email;
  }

  if (highlighted === true) {
    highlightedClassName = 'highlighted';
  }

  return (
    <div
      className={`user-item ${highlightedClassName}`}
      onClick={() => {
        add({ user: user });
        resetValue();
        closeDropDown();
      }}
    >
      {avatar}
      <FlexBox flexDirection="column">
        <div className="name">{name}</div>
        <div className="email" data-testid={user.email}>
          {email}
        </div>
      </FlexBox>
    </div>
  );
};

export default UserItem;
